/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Weighing_Approve_ConfirmInputs */

const vi_weighing_approve_confirm = /** @type {(inputs: Weighing_Approve_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xác nhận duyệt phiếu cân này?`)
};

/**

* @param {Weighing_Approve_ConfirmInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const weighing_approve_confirm = /** @type {((inputs?: Weighing_Approve_ConfirmInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Weighing_Approve_ConfirmInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_weighing_approve_confirm(inputs)
});